import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PromoCarousel from "@/components/PromoCarousel";

const MAX_CARDS = 6;

/**
 * EverydayHeroCarousel — the default (non-festive) homepage hero.
 * Same automatic live-catalog cards as the festive carousel (top deal,
 * category spotlights, brand spotlight) on charcoal + amber-glow panels
 * with the everyday "Stock Up. Stay Ready." pill.
 */
export default function EverydayHeroCarousel() {
  const [auto, setAuto] = useState(null);

  useEffect(() => {
    api.get("/shop/fest-hero")
      .then(({ data }) => setAuto(data.cards || []))
      .catch(() => setAuto([]));
  }, []);

  if (auto === null) return null;
  const cards = auto.slice(0, MAX_CARDS);
  if (cards.length === 0) return null;

  return <PromoCarousel cards={cards} pill="Stock Up. Stay Ready." panelBase="promo-hero-panel" testidPrefix="promo-hero" />;
}
